import notifications from "./notifications";

export default notifications;
